module.exports = __webpack_public_path__ + "static/apple-app-store-2928664fe1fc6aca88583a6f606d60ba.svg";